<template>
  <qc-container title="优惠券详情" v-if="detail" show-return show-divider>
    <el-descriptions :column="3" border >
      <el-descriptions-item label-class-name="w150" label="名称">{{detail.name}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="门店类型">{{['实体店','洗消店'][detail.storeType]}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="优惠券类型">{{['满减','折扣'][detail.cardType]}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="发放数量">{{detail.count}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="已领取">{{detail.receiveCount}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="已使用">{{detail.useNum}}</el-descriptions-item>

      <el-descriptions-item label-class-name="w150" label="优惠金额">订单满{{detail.fullMoney}}元,{{detail.cardType==1?"打":"立减"}}{{detail.money}}{{detail.cardType==1?"折":"元"}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="有效期">{{detail.timeType==2?"长期有效":`领取后${detail.dayTime}天内，不使用自动过期`}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="活动时间">{{detail.actTimeType==1?"长期有效":`${detail.startTime}-${detail.endTime}`}}</el-descriptions-item>

      <el-descriptions-item label-class-name="w150" label="活动对象">{{['全部商品','指定商品','指定门店'][detail.goodsType]}}</el-descriptions-item>
    </el-descriptions>
  </qc-container>
<!--  <qc-container class="mt20" :tab-list="['商品管理','订单管理','财务流水','员工管理']" :active-index="activeIndex" @changeTab="changeTab">

  </qc-container>-->
  <qc-container title="参与商品" v-if="detail&&detail.goodsType===1">
    <t-table border ref="data" style="width: 100%" :data="detail.refGoodsList" :header="goodsHeader"></t-table>
  </qc-container>
  <qc-container title="参与门店" v-if="detail&&detail.goodsType===2">
    <t-table border ref="data" style="width: 100%" :data="detail.refGoodsList" :header="shopHeader"></t-table>
  </qc-container>
  <return-box></return-box>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import UserBox from "@view/components/user-box.vue";
import ImageShow from "@/components/base/image-show.vue";
import TTable from "@/components/el/t-table.vue";
import ReturnBox from "@/components/home/return-box.vue";

export default {
  name: "coupon-detail",
  components: {ReturnBox, TTable, ImageShow, UserBox, QcContainer},
  data() {
    return {
      detail:null,
      activeIndex:0,
      shopHeader: [
        {type: "shop", label: "商家",minWidth:200},
        {label: "状态",renderDraw:row=>{
            return row.status?"禁用":"正常";
          },width: 100},
        {prop: "createTime", label: "注册时间",width: 160}
      ],
      goodsHeader:[
        {type: "goods", label: "商品",minWidth:300},
        {label: "价格",renderDraw:row=>{
            let content = "";
            if(row.storeGoodsType===1 ){
              content = "租赁价格:￥"+row.marketPrice+"元";
            }else if(row.storeGoodsType===2){
              content = "出售价格:￥"+row.salesPrice+"元<br/>"+"租赁价格:￥"+row.marketPrice+"元"
            }else{
              content = "出售价格:￥"+row.salesPrice+"元";
            }
            return content + (row.isAttribute?"起":"");
          },width:220},
        {label: "状态",renderDraw:row=>{return row.enables?"在售":"下架";},width: 100},
        //{prop: "updateTime", label: "更新时间",width:160},
        {prop: "createTime", label: "创建时间",width:160},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    changeTab(index){
      this.activeIndex = index;
    }
  },
  mounted() {
    this.simpleGet("/api/mgr/business/card/discount/detail",{id:this.$route.query.id},(res)=>{
      this.detail = res.data;
    })
  }
}
</script>


<style lang="less" scoped>
.title{
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
